import { truncate } from "@/common/helpers/string";

export const truncateAtPeriod = (text: string, targetLength: number, margin = 10): string => {
  const searchStart = Math.max(0, targetLength - margin);
  const searchEnd = Math.min(text.length, targetLength + margin);

  const periodIndex = text.slice(searchStart, searchEnd).indexOf(".");

  if (periodIndex !== -1) {
    return text.slice(0, Math.max(0, searchStart + periodIndex + 1));
  }

  return truncate(text, { length: targetLength });
};
